// extracted by mini-css-extract-plugin
export default {"stop0":"fouw0UHJpZc","stop1":"fouo4LSvVFe","stop2":"fouZUSbPiVl","stop3":"fouc78pm4tS","stop4":"fouoyDvooXl"};